export const getSelectStyles = (error) => ({
    control: (base, state) => ({
      ...base,
      borderColor: error
        ? "#dc3545" // red if error
        : state.isFocused
        ? "#86b7fe" // bootstrap focus blue
        : "#ced4da", // normal bootstrap border

      minHeight: "38px", // match bootstrap height
    }),
  });

  export const formatSeriesLabel = (value) => {
    if (!value) return "";

    const [year, month] = value.split("-");
    const date = new Date(year, month - 1);

    return date.toLocaleString("en-US", {
      month: "long",
      year: "numeric",
    });
  };

  export const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

  export const normalizeRemarks = (value = "") => {
    return value
      .replace(/<p><br><\/p>/gi, "")
      .replace(/&nbsp;/gi, " ")
      .trim();
  };

  /* ── Helpers ─────────────────────────────────────────────────────── */
// Resolve relative file paths against onsite_url (same base used by interceptorServices)
export const toFullUrl = (url, onsite_url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  const base = (onsite_url || "http://localhost:8181").replace(/\/$/, "");
  return `${base}/${url.replace(/^\//, "")}`;
};

export const fmtSize = (b) =>
  !b ? "" : b < 1024 ? `${b}B` : b < 1048576 ? `${(b / 1024).toFixed(0)}KB` : `${(b / 1048576).toFixed(1)}MB`;
